import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource/space-grotesk/latin-400.css';
import '@fontsource/space-grotesk/latin-500.css';
import '@fontsource/space-grotesk/latin-700.css';
import '@fontsource/anton';
import '@fontsource/teko/latin-400.css';
import '@fontsource/teko/latin-500.css';
import '@fontsource/teko/latin-600.css';
import '@fontsource/teko/latin-700.css';
import './tailwind.css';
import './styles.css';

function getErrorDetails(error) {
  if (!error) {
    return 'Unknown error';
  }

  if (typeof error === 'string') {
    return error;
  }

  return error.stack || error.message || JSON.stringify(error, null, 2);
}

function showPreviewError(title, error) {
  const root = document.getElementById('preview-error-overlay') || document.createElement('div');
  root.id = 'preview-error-overlay';
  root.style.position = 'fixed';
  root.style.inset = '0';
  root.style.zIndex = '999999';
  root.style.padding = '24px';
  root.style.background = '#0a0c0f';
  root.style.color = '#f5f7fa';
  root.style.fontFamily = 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace';
  root.style.fontSize = '13px';
  root.style.lineHeight = '1.55';
  root.style.whiteSpace = 'pre-wrap';
  root.style.overflow = 'auto';
  root.style.borderTop = '4px solid #d6ff18';
  root.innerHTML = `<strong style="display:block;margin-bottom:12px;font-size:15px;color:#d6ff18;">${title}</strong>${getErrorDetails(error)}`;

  if (!root.isConnected) {
    document.body.appendChild(root);
  }
}

window.addEventListener('error', (event) => {
  showPreviewError('Window Error', event.error || event.message);
});

window.addEventListener('unhandledrejection', (event) => {
  showPreviewError('Unhandled Promise Rejection', event.reason);
});

class PreviewErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    showPreviewError('React Render Error', `${getErrorDetails(error)}\n\n${info.componentStack}`);
  }

  render() {
    if (this.state.error) {
      return null;
    }

    return this.props.children;
  }
}

async function bootstrap() {
  try {
    const [{ default: App }] = await Promise.all([import('./App')]);

    ReactDOM.createRoot(document.getElementById('root')).render(
      <React.StrictMode>
        <PreviewErrorBoundary>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </PreviewErrorBoundary>
      </React.StrictMode>,
    );
  } catch (error) {
    showPreviewError('Boot Error', error);
  }
}

bootstrap();
